<template>
  <li>
    <div v-if="hasOwnSite" class="own-site-box">
      <span v-if="item.isOwnSite" class="own-site">登録サイト</span>
    </div>
    <template v-if="!item.url && item.isOwnSite">
      <span class="rank">圏外</span>
      <span>
        100位以内に登録サイトのデータが存在しません。
      </span>
    </template>
    <template v-else>
      <span class="rank">{{ item.rank }}位</span>
      <a :href="item.url" target="_blank" class="c-link--blank">
        <EllipsisTip>{{ item.url }}</EllipsisTip>
      </a>
      <template v-if="item.contentType === 'pdf'">
        <span class="exception-txt">
          PDFのため分析ができません。
        </span>
      </template>
      <template v-else-if="item.headers.volume === null">
        <span class="exception-txt">
          文字量を取得中です。
        </span>
      </template>
      <template v-else-if="typeof item.headers.volume === 'undefined'">
        <div class="exception-txt">
          文字量を取得できませんでした。
          <Tooltip variant="attention">
            データの取得ができませんでした。
            原因は対象のサイトでIPアドレスのブロックなどの理由でデータを取得できなかったことが考えられます。
          </Tooltip>
        </div>
      </template>
      <template v-else-if="item.headers.volume === 0">
        <div class="exception-txt">
          文字量を取得できませんでした。
          <Tooltip variant="attention">
            データの取得ができませんでした。
            原因は対象のサイトでIPアドレスのブロックなどの理由でデータを取得できなかったことが考えられます。
          </Tooltip>
        </div>
      </template>
      <template v-else>
        <span class="txt">{{ item.headers.volume | separateNumber }}文字</span>
        <div class="line">
          <div
            class="p-contentplans-graph__bar"
            :style="{ height: '10px', width: barW + '%' }"
          ></div>
        </div>
      </template>
    </template>
  </li>
</template>

<script>
import EllipsisTip from '@/components/EllipsisTip';
import Tooltip from '@/components/Tooltip';

export default {
  props: ['item', 'max', 'hasOwnSite'],
  data() {
    return {
      barW: 0,
      timeout: null
    };
  },
  components: {
    EllipsisTip,
    Tooltip
  },
  watch: {
    'item.headers.volume': {
      handler(value) {
        this.update();
      }
    },
    max: {
      handler(value) {
        this.update();
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.timeout = setTimeout(() => {
        this.update();
      }, 100);
    });
  },
  destroyed() {
    clearTimeout(this.timeout);
  },
  methods: {
    update() {
      let value = this.item.headers.volume;
      if (value && this.max) {
        this.barW = (value / this.max) * 100;
      }
    }
  }
};
</script>
